const FEATURES = ['lossy', 'lossless', 'alpha', 'animation']

const checkImages = {
  lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
  lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
  alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
  animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
};


function checkWebpFeature(feature, callback) {
  var img = new Image();
  img.onload = function () {
    var result = (img.width > 0) && (img.height > 0);
    callback(result);
  };
  img.onerror = function () {
    callback(false);
  };
  img.src = "data:image/webp;base64," + checkImages[feature];
}

function caniuseWebp(callback, feature = 'all') {
  const result = {}
  let resolve;
  let p;
  if (!callback) {
    p = new Promise(function(_resolve) {
      resolve = _resolve
    })
  } else {
    resolve = function(res) {
      callback(res)
    }
  }

  if (feature === 'all') {
    FEATURES.forEach((feat, index) => {
      checkWebpFeature(feat, function(res) {
        result[feat] = res;
        ++index;
        if (index === FEATURES.length) {
          const isAll = Object.values(result).every(Boolean);
          resolve(isAll, result)
        }
      })
    })
  } else {
    checkWebpFeature(feature, resolve)
  }

  if (!callback) return p;
}

const imageUtil = {
  caniuseWebp
}

export default imageUtil
